export const errorPass = {
    text: 'Your Password is missing ',
    lowercase: 'one lowercase',
    uppercase: 'one uppercase',
    number: 'one number',
    symbol: 'one Symbol',
    min: 'min 8 characters',
};